import script from "./ListarFormulariosAvaliacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarFormulariosAvaliacoes.vue?vue&type=script&setup=true&lang=js"

import "./ListarFormulariosAvaliacoes.vue?vue&type=style&index=0&id=5438e458&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5438e458"]])

export default __exports__